import { ThreeCircles } from "react-loader-spinner";


const Loader = (props) => {
    return (
        <>
        {props.start ? 
        <div className="page-loader">
            <div className="fixed-loader-d position-fixed">
                <ThreeCircles
                height="100"
                width="100"
                color=""
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor="#415385"
                innerCircleColor="#415385"
                middleCircleColor="#415385"
                />
                {props.msg ? <p>{props.msg}</p> : ""}
            </div> 
        </div>
        : ''}
        </>
    )
}

export default Loader;